export default {
  '500': 'Internal Server Error',
  '502': '502 Bad Gateway',
  '403': 'No Permissions',
  '404': '404 Not Found',
  'Unauthorized': 'Unauthorized'
}
